export default "__VITE_ASSET__BEmdeJbc__"